module.exports = __webpack_public_path__ + "static/media/icon30.18f93aae.svg";